// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CHECK_URL } from "src/app/shared/functions/check-env";

export const environment = {
  production: false,
   base_url: CHECK_URL()
  // base_url: 'https://cheilcros-api-hlg.cheilcros.com/api/v1'
  // base_url: 'https://api.cheilcros.com/api/v1'
  //base_url: 'http://localhost:3000/api/v1'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
